const POTENCIA_SPEC = {
  label: 'Potência — trifásico',
  caption: 'Subestação · tanque 3,2 × 1,8 × 1,7 m · 3 fases',
  tank: { width: 3.2, height: 1.8, depth: 1.7 },
  fins: { front: 16, side: 8, depth: 0.22 },
  bushings: {
    phases: 3,
    hv: {
      height: 1.0, sheds: 7, shaftRadius: 0.055, shedRadius: 0.16, step: 0.95,
    },
    lv: {
      height: 0.55, sheds: 5, shaftRadius: 0.05, shedRadius: 0.13, step: 0.75,
    },
  },
  conservator: { radius: 0.40 },
};

const TFMP_MESH = {
  url: '/static/models/transformador-tfmp.glb',
  alturaAlvo: 9.5,
  giroY: Math.PI / 2,
};

export const TRANSFORMER_MODELS = [
  { id: 'potencia', ...POTENCIA_SPEC, mesh: TFMP_MESH },
  { id: 'potencia-2', ...POTENCIA_SPEC, mesh: TFMP_MESH },
  { id: 'potencia-3', ...POTENCIA_SPEC, mesh: TFMP_MESH },
];

export const DEFAULT_MODEL_ID = TRANSFORMER_MODELS[0].id;

export function modelIdForAssetIndex(index) {
  if (!Number.isInteger(index) || index < 0) return DEFAULT_MODEL_ID;
  return TRANSFORMER_MODELS[index % TRANSFORMER_MODELS.length].id;
}
